import { render, staticRenderFns } from "./AuthenticationForm.vue?vue&type=template&id=d27216f0&scoped=true&"
import script from "./AuthenticationForm.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationForm.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationForm.vue?vue&type=style&index=0&id=d27216f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27216f0",
  null
  
)

export default component.exports